import { init, withScope, captureException, setUser } from "@sentry/browser";
import { UserOutline } from "components/modules/API";

export function initializeSentry(
  environment: "production" | "development",
): void {
  init({
    dsn: "https://8852e6099b17478d8a5961b88faa451b:964de32c31a540adb20c32148bf61fe8@o4504618587914240.ingest.sentry.io/4504618587914240",
    integrations: [],
    tracesSampleRate: 1.0,
    environment: environment,
  });
}

type extraArgs = {
  [key: string]: any;
};
export function sendErrorToSentry(error: Error, extraArgs?: extraArgs) {
  extraArgs = extraArgs || {};

  withScope((scope) => {
    Object.keys(extraArgs).forEach((key) => {
      scope.setExtra(key, extraArgs[key]);
    });
    captureException(error);
  });
}

export function sendMessageToSentry(message: any, extraArgs?: extraArgs) {
  // If message is already an Error, use that, otherwise wrap it in new Error
  if (message instanceof Error) {
    sendErrorToSentry(message, extraArgs);
    return;
  }

  sendErrorToSentry(new Error(message), extraArgs);
}

export function setSentryUser(user: UserOutline) {
  setUser({ id: user.id.toString() });
}
